import React, { useState, useEffect, useContext, memo } from "react";

import { toast } from "react-toastify";
import theme from "../theme.jsx";
import {
	Paper,
	Tooltip,
	Typography,
	Divider,
	Button,
	ButtonGroup,
	Grid,
	Card,
	Chip,
	Switch,
		Skeleton,
} from "@mui/material";
import { Context } from "../context/ContextApi.jsx";

import { useNavigate, Link } from "react-router-dom";
import Priority from "../components/Priority.jsx";
import { constrainMatrix } from "reaviz";
//import { useAlert 

const Priorities = memo((props) => {
  const { globalUrl, userdata,clickedFromOrgTab, serverside, billingInfo, stripeKey, checkLogin, setAdminTab, setCurTab, notifications, setNotifications, } = props;
  
  const [showDismissed, setShowDismissed] = React.useState(false);
  const [showRead, setShowRead] = React.useState(false);
  const [appFramework, setAppFramework] = React.useState({});
  const [selectedWorkflow, setSelectedWorkflow] = React.useState("NO HIGHLIGHT");
  const [selectedExecutionId, setSelectedExecutionId] = React.useState("NO HIGHLIGHT");
  const [highlightKMS, setHighlightKMS] = React.useState(false)
  
  let navigate = useNavigate();
	useEffect(() => {
		getFramework()

		// Check "workflow" and "execution_id" in URL
		const urlParams = new URLSearchParams(window.location.search)
		const workflow = urlParams.get("workflow")
		const execution_id = urlParams.get("execution_id")
		const kms = urlParams.get("kms")

		if (kms !== null && kms !== undefined && kms.length > 0 && kms === "true") {
			toast.info("KMS-related notifications are highlighted.")
			setHighlightKMS(true)
		}

		if (execution_id !== null) {
			setSelectedExecutionId(execution_id)

			//toast.info("Execution-related notifications are highlighted.")
		} 

		if (workflow !== null) {
			setSelectedWorkflow(workflow)

			toast.info("Workflow-related notifications are highlighted.")
		}
	}, [])

	if (userdata === undefined || userdata === null) {
		return 
	}

	const getFramework = () => {
		fetch(globalUrl + "/api/v1/apps/frameworkConfiguration", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			credentials: "include",
		})
		.then((response) => {
			if (response.status !== 200) {
				console.log("Status not 200 for framework!");
			}

			return response.json();
		})
		.then((responseJson) => {
			if (responseJson.success === false) {
				setAppFramework({})
				if (responseJson.reason !== undefined) {
					//toast("Failed loading: " + responseJson.reason)
				} else {
					//toast("Failed to load framework for your org.")
				}
			} else {
				setAppFramework(responseJson)
			}
		})
		.catch((error) => {
			console.log("err in framework: ", error.toString());
		})
	}

	const clearNotifications = () => {
	  // Don't really care about the logout

	  toast("Clearing notifications")
	  fetch(`${globalUrl}/api/v1/notifications/clear`, {
		credentials: "include",
		method: "GET",
		headers: {
		  "Content-Type": "application/json",
		},
	  })
		.then(function (response) {
		  if (response.status !== 200) {
			console.log("Error in response");
		  }

		  return response.json();
		})
		.then(function (responseJson) {
		  if (responseJson.success === true) {
			  // Reload the UI
			  const newNotifications = notifications.map((notification) => {
				  notification.read = true
				  return notification
			  })

			  setNotifications(newNotifications)
			  setShowRead(true)
		  } else {
			toast("Failed dismissing notifications. Please try again later.");
		  }
		})
		.catch((error) => {
		  console.log("error in notification dismissal: ", error);
		  //removeCookie("session_token", {path: "/"})
		});
	};

	const dismissNotification = (alert_id, disabled) => {
		var notificationurl = `${globalUrl}/api/v1/notifications/${alert_id}/markasread`
		if (disabled === true) {
			notificationurl += "?disabled=true"
		} else if (disabled === false) {
			notificationurl += "?disabled=false"
		}

		fetch(notificationurl , {
		  credentials: "include",
		  method: "GET",
		  headers: {
			"Content-Type": "application/json",
		  },
		})
		.then(function (response) {
		  if (response.status !== 200) {
			console.log("Error in response");
		  }

		  return response.json();
		})
		.then(function (responseJson) {
		  if (responseJson.success === true) {
			// Mark current one as read
			var newNotifications = notifications.map((notification) => {
				if (notification.id === alert_id) {
					notification.read = true
				}

				return notification
			})


			if (disabled === true) {
				toast("Notification disabled, and will not be shown again.")

				newNotifications = newNotifications.map((notification) => {
					if (notification.id === alert_id) {
						notification.ignored = true
					}

					return notification
				})

				console.log("NEW NOTIFICATIONS: ", newNotifications);
			} else if (disabled === false) {
				toast("Notification re-enabled successfully")

				newNotifications = newNotifications.map((notification) => {
					if (notification.id === alert_id) {
						notification.ignored = false
					}

					return notification
				})

			} else {
				toast("Notification dismissed successfully")
			}

			//const newNotifications = notifications.filter(
			//	(data) => data.id !== alert_id
			//)

			//console.log("NEW NOTIFICATIONS: ", newNotifications);

			if (setNotifications !== undefined && newNotifications !== undefined) {
				setNotifications(newNotifications)
			}
		  } else {
			toast("Failed dismissing notification. Please try again later.");
		  }
		})
		.catch((error) => {
		  console.log("error in notification dismissal: ", error);
		  //removeCookie("session_token", {path: "/"})
		})
	}
	

	const notificationWidth = "100%" 
	const imagesize = 22
	const boxColor = "#86c142"

	return (
		<div id="container-1-priorities-admin-page" style={{width: "100%", height: "100%", boxSizing: 'border-box', transition: 'width 0.3s ease', padding: clickedFromOrgTab ? "27px 10px 19px 27px":null, height: clickedFromOrgTab ? "auto":null, minHeight: 843, backgroundColor: clickedFromOrgTab ? '#212121':null, borderRadius: clickedFromOrgTab ? '16px':null,  }}>
		  <div id="container-2-priorities-admin-page" style={{ maxHeight: 1700,  overflowY: "auto", width: '100%', scrollbarColor: '#494949 transparent', scrollbarWidth: 'thin'}}>
			<div id="container-3-priorities-admin-page" style={{maxWidth: "calc(100% - 20px)"}}>
		  <Typography id="typography-1-priorities-admin-page" style={{ fontSize: 24, fontWeight: 'bold', display: clickedFromOrgTab?null:"inline", marginBottom: clickedFromOrgTab? 8:null, color: clickedFromOrgTab?"#ffffff":null }}>Notifications ({
				notifications?.filter((notification) => showRead === true || notification.read === false).length
				})</Typography>

			<span id="span-1-priorities-admin-page" style={{ fontSize: 16,  marginLeft: clickedFromOrgTab?null:25, color: clickedFromOrgTab?"#9E9E9E":null, }}>
				Notifications help you find potential problems with your workflows and apps.&nbsp;
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://documents.arguscyber.ai/docs/argus-soar/"
					id="anchor-1-priorities-admin-page" style={{ textDecoration: clickedFromOrgTab?null:"none", color: clickedFromOrgTab?"#FF8444":"#f85a3e" }}
				>
					Learn more
				</a>
			</span>
			<div/>
			<div id="container-4-priorities-admin-page" style={{display: "flex", marginTop: 10, marginBottom: 10, }}>
				<Switch
					checked={showRead}
					onChange={() => {
						setShowRead(!showRead);
					}}
				/><span id="span-2-priorities-admin-page" style={{marginTop: 5, }}>&nbsp; Show read </span>
				  {notifications !== undefined && notifications !== null && notifications.length > 1 ? (
					<Button
					  color="primary"
					  variant="outlined"
					  disabled={notifications.filter((data) => !data.read).length === 0}
					  onClick={() => {
						clearNotifications()
					  }}
					  id="button-1-priorities-admin-page" style={{marginLeft: 50, textTransform: "none", fontSize: 16}}
					>
					  Mark all as read 
					</Button>
				  ) : null}
			</div>
			<NotificationComponent  notifications={notifications} showRead={showRead} selectedExecutionId={selectedExecutionId} selectedWorkflow={selectedWorkflow} highlightKMS={highlightKMS} userdata={userdata} imagesize={imagesize} boxColor={boxColor} clickedFromOrgTab={clickedFromOrgTab} notificationWidth={notificationWidth} dismissNotification={dismissNotification}/>

			{clickedFromOrgTab? null : <Divider id="divider-1-priorities-admin-page" style={{marginTop: 50, marginBottom: 50, }} />}
			<h2 id="h2-1-priorities-admin-page" style={{ display: clickedFromOrgTab ? null:"inline", marginBottom: clickedFromOrgTab ? 8:null, marginTop: clickedFromOrgTab ? 30 :null, color: clickedFromOrgTab ? "#ffffff" : null }}>Suggestions</h2>
			<span id="span-3-priorities-admin-page" style={{ fontSize: 16, color: clickedFromOrgTab ?"#9E9E9E":null,marginLeft: clickedFromOrgTab ?null:25,  }}>
				Suggestions are tasks identified by Argus-Soar to help you discover ways to protect your and customers' company. <br/>These range from simple configurations in Argus-Soar to Usecases you may have missed.&nbsp;
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://documents.arguscyber.ai/docs/argus-soar/"
					id="anchor-2-priorities-admin-page" style={{ textDecoration: clickedFromOrgTab ?null:"none", color: clickedFromOrgTab ?"#FF8444":"#f85a3e" }}
				>
					Learn more
				</a>
			</span>
			<div id="container-5-priorities-admin-page" style={{marginTop: 10, }}/>
			<Switch
				checked={showDismissed}
				onChange={() => {
					setShowDismissed(!showDismissed);
				}}
			/>&nbsp; Show dismissed
			{userdata.priorities === null || userdata.priorities === undefined || userdata.priorities.length === 0 ? 
				<Typography variant="h4">
					No Suggestions found
				</Typography>
				: 
				userdata.priorities.map((priority, index) => {
					if (showDismissed === false && priority.active === false) {
						return null
					}

					return (
						<Priority
							key={index}
							globalUrl={globalUrl}
							priority={priority}
							checkLogin={checkLogin}
							clickedFromOrgTab={true}
							setAdminTab={setAdminTab}
							setCurTab={setCurTab}
							appFramework={appFramework}
						/>
					)
				})
			}
		  </div>
		  </div>
		</div>
	)
})

export default Priorities;


const NotificationItem = memo((props) => {
	const {data, selectedExecutionId, selectedWorkflow, highlightKMS, userdata, imagesize, boxColor, clickedFromOrgTab, notificationWidth, dismissNotification} = props

	var image = "";
	var orgName = "";
	var orgId = "";

	
	var highlighted = selectedExecutionId === "" && selectedWorkflow === "" ? false : data.reference_url === undefined || data.reference_url === null || data.reference_url.length === 0 ? false : data.reference_url.includes(selectedExecutionId) || data.reference_url.includes(selectedWorkflow) 

	if (!highlighted && highlightKMS) {
		if (data.title !== undefined && data.title !== null && data.title.toLowerCase().includes("kms")) {
			highlighted = true
		} else if (data.description !== undefined && data.description !== null && data.description.toLowerCase().includes("kms")) {
			highlighted = true
		}

	}

	if (userdata.orgs !== undefined) {
	  const foundOrg = userdata.orgs.find((org) => org.id === data["org_id"]);
	  if (foundOrg !== undefined && foundOrg !== null) {
		//position: "absolute", bottom: 5, right: -5,
		const imageStyle = {
		  width: imagesize,
		  height: imagesize,
		  pointerEvents: "none",
		  marginLeft:
			data.creator_org !== undefined && data.creator_org.length > 0
			  ? 20
			  : 0,
		  borderRadius: 10,
		  border:
			foundOrg.id === userdata.active_org.id
			  ? `3px solid ${boxColor}`
			  : null,
		  cursor: "pointer",
		  marginRight: 10,
		};

		image =
		  foundOrg.image === "" ? (
			<img
			  alt={foundOrg.name}
			  src={theme.palette.defaultImage}
			  id="image-1-notificationitem-admin-page" style={imageStyle}
			/>
		  ) : (
			<img
			  alt={foundOrg.name}
			  src={foundOrg.image}
			  id="image-2-notificationitem-admin-page" style={imageStyle}
			  onClick={() => {}}
			/>
		  );

		orgName = foundOrg.name;
		orgId = foundOrg.id;
	  }
	}

	return (
	 <Paper
			 id="paper-1-notificationitem-admin-page"
			 style={{
			   display: 'flex',
			   flexDirection: 'column',
			   flex: 1,
			   backgroundColor: '#292929',
			   width: '100%',
			   padding: 30,
			   border: highlighted ? '2px solid #f85a3e' : '1px solid #747474',
			   borderRadius: 10,
			   marginBottom: 20,
			   position: 'relative', // important for absolute-positioning the chip
			 }}
		   >
			 {/* 📌 Top-left chip (positioned over border) */}
			 <div
  id="chip-wrapper"
  style={{
	position: 'absolute',
	top: -12,
	left: 20, // ✅ shifted right slightly to match design
	zIndex: 2,
	//backgroundColor: '#292929', // ✅ matches Paper background to blend
	paddingLeft: 6,
	paddingRight: 6,
	height: 24,
	display: 'flex',
	alignItems: 'center',
	borderRadius: 20,
  }}
>
  <Chip
	label={data.read ? "Read" : "Unread"}
	size="small"
	style={{
	  backgroundColor: '#545454',
	  color: 'white',
	  fontWeight: 500,
	  height: 24,
	  paddingLeft: 8,
	  paddingRight: 8,
	  borderRadius: 16,
	}}
  />
</div>

		   
			 {/* 🔽 Main Title */}
			 <Typography
			   variant="h6"
			   style={{
				 fontWeight: 600,
				 color: 'white',
				 marginTop: 10,
				 marginBottom: 10,
			   }}
			 >
			   {data.title}
			 </Typography>
		   
			 {/* 🔴 Description (Red alert with icon if exists) */}
			 {data.description && (
			   <Typography
				 variant="body2"
				 style={{
				   color: '#f44336',
				   fontSize: 15,
				   marginBottom: 16,
				   display: 'flex',
				   alignItems: 'center',
				 }}
			   >
				 <span style={{ marginRight: 6 }}>⚠️</span>
				 {data.description}
			   </Typography>
			 )}
		   
			 {/* 🔳 Metadata Row */}
			 <div
			   style={{
				 display: 'flex',
				 backgroundColor: '#2f2f2f',
				 padding: '10px 16px',
				 borderRadius: 6,
				 color: 'white',
				 marginBottom: 20,
				 fontSize: 14,
				 flexWrap: 'wrap',
				 gap: '10px',
			   }}
			 >
			   <b>First seen:</b> {new Date(data.created_at * 1000).toISOString().slice(0, 19)} |
			   <b> Last seen:</b> {new Date(data.updated_at * 1000).toISOString().slice(0, 19)} |
			   <b> Times seen:</b> {data.amount}
			 </div>
		   
			 {/* 🧭 Buttons */}
			 <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
			   <Button
				 variant="contained"
				 style={{
				   backgroundColor: '#ff6600',
				   color: 'white',
				   padding: '6px 16px',
				   textTransform: 'none',
				   borderRadius: 6,
				 }}
				 disabled={!data.reference_url}
				 onClick={() => window.open(data.reference_url, '_blank')}
				 startIcon={<span>🔍</span>}
			   >
				 Explore
			   </Button>
		   
			   {data.read === false && (
				 <Button
				   variant="outlined"
				   color="secondary"
				   onClick={() => dismissNotification(data.id)}
				   style={{ textTransform: 'none', borderRadius: 6 }}
				   startIcon={<span>✔️</span>}
				 >
				   Mark read
				 </Button>
			   )}
		   
			   <Button
				 variant="outlined"
				 color="secondary"
				 onClick={() =>
				   dismissNotification(data.id, data.ignored ? false : true)
				 }
				 disabled={!data.dismissable}
				 style={{
				   textTransform: 'none',
				   opacity: data.ignored || data.dismissable ? 1 : 0.5,
				   cursor: data.dismissable ? 'pointer' : 'not-allowed',
				   borderRadius: 6,
				 }}
				 startIcon={<span>🚫</span>}
			   >
				 {data.ignored ? 'Re-enable' : 'Disable'}
			   </Button>
			 </div>
		   </Paper>
	 
	);
})


const NotificationComponent = memo(({notifications, showRead, selectedExecutionId, selectedWorkflow, highlightKMS, userdata, imagesize, boxColor, clickedFromOrgTab, notificationWidth, dismissNotification}) => {

	return(
		<div>
			{notifications === null || notifications === undefined || notifications?.length === 0 ? (
			null
		) : 
		
			<div>
			<Grid
  container
  spacing={2}
  alignItems="stretch"
  id="grid-notification-list-admin-page"
>
  {notifications?.map((notification, index) => {
	if (showRead === false && notification.read === true) {
	  return null;
	}

	return (
	  <Grid
		item
		xs={12}
		sm={6}
		key={index}
		style={{ display: 'flex' }} // ensures equal height columns
	  >
		<NotificationItem
		  data={notification}
		  selectedExecutionId={selectedExecutionId}
		  selectedWorkflow={selectedWorkflow}
		  highlightKMS={highlightKMS}
		  userdata={userdata}
		  imagesize={imagesize}
		  boxColor={boxColor}
		  clickedFromOrgTab={clickedFromOrgTab}
		  notificationWidth={null} // let grid handle the width
		  dismissNotification={dismissNotification}
		  style={{ flex: 1 }} // stretch the card height
		/>
	  </Grid>
	);
  })}
</Grid>


			</div>
		}
		</div>
	)
})

// const PaddingWrapper = memo(({children, clickedFromOrgTab}) => {

// 	const { leftSideBarOpenByClick } = useContext(Context)

// 	return(
// 		<div id="prioritiesadminpage" style={{width: leftSideBarOpenByClick ? 950 : 1030,transition: 'width 0.3s ease', padding: clickedFromOrgTab ? "27px 10px 19px 27px":null, height: clickedFromOrgTab ? "auto":null, minHeight: 843, backgroundColor: clickedFromOrgTab ? '#212121':null, borderRadius: clickedFromOrgTab ? '16px':null,  }}>
// 			{children}
// 		</div>
// 	)
// })

// const Wrapper = memo(({children, clickedFromOrgTab}) => {

// 	return(
// 		<PaddingWrapper clickedFromOrgTab={clickedFromOrgTab}>
// 			{children}
// 		</PaddingWrapper>
// 	)
// })
